import axios from "axios";
import { logger } from "../utilities/logger";
const URL = window.RUNTIME_CONFIG.API_BASE_URL;
const BASE_URL = `${URL}/azureblb`;

export class AzureBlobStorageService {
  static async GenerateSASToken() {
    try {
      const response = await axios.get(`${BASE_URL}/sastoken`);
      return response.data;
    } catch (err) {
      logger.error("GenerateSASToken failed:", err.response?.data ?? err.message);
      throw err;
    }
  }
}
